/* eslint-disable */ 
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import playerModel from './player-model';

const KEY_PLAYERS = 'players'
const KEY_TEAMS = 'teams'
const NAME_ENTITY= 'player'
const KEY_CLUBS= 'clubs'

export default {

  list() {
    return new Promise((resolve) => {
      db.ref(KEY_PLAYERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  listByTeamId(teamId) {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS).child(teamId).child(KEY_PLAYERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },


  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      db.ref(KEY_PLAYERS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          return null;
        }
        
        // Si no tiene picture
        if (model.picture.name === "") {
          resolve(model)
        }

        fileService.fillDownloadURL(
          KEY_PLAYERS,
          model.id,
          'picture',
          model.picture
        ).then(() => {
          resolve(model)
        }).catch((error) => {
          reject(error)
        });
      })
    });
  },

  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ model.id] = null;
      updates['/' + KEY_PLAYERS + '/' + model.id ] = null;
      updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ model.id] = null;

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data deleted successfully!
          fileService.delete(KEY_PLAYERS, model.id, 'picture', model.picture)
          .then(() => {
              // Logs 
              logService.log(modelToDestroy, "deleted", KEY_PLAYERS, NAME_ENTITY)
              resolve()
            }).catch((error) => {
              reject(error)
            });
        }
      })
    })
  },

  update(model, loggedUser) {
    const modelToUpdate = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadB64Img(KEY_PLAYERS, modelToUpdate.id, 'picture', modelToUpdate.picture)
        .then(() => {
          var updates = {};
          updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ model.id] = playerModel.forTeam(modelToUpdate);
          updates['/' + KEY_PLAYERS + '/' + model.id ] = playerModel.forUpdate(modelToUpdate);
          updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ model.id] = playerModel.forTeam(modelToUpdate);
  
          db.ref().update(updates, (error) => {            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Data saved successfully!
              // Logs
              logService.log(modelToUpdate, "modified", KEY_PLAYERS, NAME_ENTITY)
              resolve()
            }
          })
        }).catch((error) => {
          reject(error)
        });
      });
  },

  create(model, loggedUser) {
    const modelToSave = {
      ...model,
      id: db.ref(KEY_PLAYERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };
    console.log("<--- CREATE PLAYER");
    console.log(modelToSave);
    

    return new Promise((resolve, reject) => {
      
      fileService.uploadB64Img(KEY_PLAYERS, modelToSave.id, 'picture', modelToSave.picture)
      .then(() => {
        var updates = {};
        updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ modelToSave.id] = playerModel.forTeam(modelToSave);
        updates['/' + KEY_PLAYERS + '/' + modelToSave.id ] = playerModel.forCreate(modelToSave);
        updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/'+ modelToSave.id] = playerModel.forTeam(modelToSave);

        db.ref().update(updates, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            // Logs
            logService.log(modelToSave, "created", KEY_PLAYERS, NAME_ENTITY)
            resolve()
          }
        });
      }).catch((error) => {
        reject(error)
      });
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_PLAYERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.label = childSnapshot.val().name

          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-service.js